<template>
  <div>

    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 산업재해 발생정보-->
    <write-grid-container title="산업재해 발생정보" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{ form.subInfo[value] }}</div>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <template v-else-if="dataType === 'radio1' || dataType === 'radio2'" >
            <vs-radio v-for="option in result_options[dataType]" :key="`${dataType}${option}`" v-model="form.subInfo[value]" :vs-name="dataType" :vs-value="option" class="mx-2">{{
                option
              }}</vs-radio>
          </template>
          <div v-else-if="dataType === 'cal'" class="flex" style="align-items: center">
            <ml-input class="w-full" type="number" v-model="form.subInfo[value]" :readonly="true" />
            <span class="ml-2" style="font-weight: 500">일</span>
          </div>
          <div v-else-if="dataType === 'year'" class="flex" style="align-items: center">
            <ml-input class="w-full" type="number" v-model="form.subInfo[value]" :min-value="0" :max-value="100" />
            <span class="ml-2" style="font-weight: 500">년</span>
          </div>
          <disaster-class-selector v-else-if="dataType === 'disaster'" v-model="form.subInfo[value]" class="w-full" />
          <file-uploader v-else-if="dataType === 'file'" v-model="form.subInfo[value]" />
          <div v-else-if="dataType === 'blank'" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" :max="100" />
        </div>
      </template>
    </write-grid-container>

    <!--    파일첨부-->
    <file-upload-module class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FileUploader,
    DisasterClassSelector,
    FileDownloadPost,
    CustomOptionSelector,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    funcRefreshButtons: Function // 상단 버튼 새로고침
  },
  validations: {
    form: {
      subInfo: {
        재해일시: { required },
        요양일수: {
          if(value) {
            // 복직일을 입력 안하면 통과
            if (this.form.subInfo["복직일"] === "") return true;

            // 복직일을 입력하면 요양일수를 계산
            this.warningInfo = !(value >= 0);
            return !this.warningInfo;
          },
        },
      },
    },
  },
  data() {
    return {
      warningInfo: false,
      result_options: {
        radio1: ["직영", "사내수급", "사외수급"],
        radio2: ["승인", "진행중", "불승인"],
      },
      gridContainerOptions: {
        dataTypes: ["date", "string", "radio1", "string", "year", "year", "disaster", "date", "cal", "radio2", "blank", "blank", "file", "file", "file", "file", "string"],
        labels: ["재해일시", "재해장소", "구분", "팀명/업체명", "근속년수", "해당직무근속년수", "재해형태", "복직일", "요양일수", "산재승인여부", "", "", "재해속보", "합동조사회의록", "재발방지대책", "개선결과", "기타"],
        values: ["재해일시", "재해장소", "구분", "팀명_업체명", "근속년수", "해당직무근속년수", "재해형태", "복직일", "요양일수", "산재승인여부", "", "", "재해속보", "합동조사회의록", "재발방지대책", "개선결과", "기타"],
      },

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
        connect1107Id: null
      },

      connect944Id: null,
      connect945Id: null,
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.subInfo.재해일시": {
      immediate: true,
      deep: true,
      handler(value) {
        let 재해일시 = this.form.subInfo["재해일시"];
        let 복직일 = this.form.subInfo["복직일"];
        if (!재해일시 || 재해일시 === "" || !복직일 || 복직일 === "") {
          this.form.subInfo["요양일수"] = "";
          return;
        }
        if (this.$moment(재해일시).isAfter(복직일)) {
          this.form.subInfo["요양일수"] = -1;
          this.form.subInfo["복직일"] = "";
          return;
        }

        let result = this.$moment(복직일).diff(재해일시, "days");
        this.form.subInfo["요양일수"] = result;
      },
    },
    "form.subInfo.복직일": {
      immediate: true,
      deep: true,
      handler(value) {
        let 재해일시 = this.form.subInfo["재해일시"];
        let 복직일 = this.form.subInfo["복직일"];
        if (!재해일시 || 재해일시 === "" || !복직일 || 복직일 === "") {
          this.form.subInfo["요양일수"] = "";
          return;
        }
        if (this.$moment(재해일시).isAfter(복직일)) {
          this.form.subInfo["요양일수"] = "";
          this.form.subInfo["재해일시"] = "";
          return;
        }

        let result = this.$moment(복직일).diff(재해일시, "days");
        this.form.subInfo["요양일수"] = result;
      },
    },
  },
  async created() {
    this.$store.commit("board/SET_BOARD_CONNECT_823", null);

    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    // 연결된 944, 945 postId를 찾는다.
    if (this.postId) {
      const apiOptions = {
        projectId: this.projectId,
        page: 1,
        perPage: 1,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions: [{ key: "body.connect823Id", operator: "=", value: `${this.postId}` }],
      };

      // 944, 945 호출
      const [res944, res945] = await Promise.all([this.$store.dispatch("approval/LOAD_POST_ALL", { ...apiOptions, boardSlug: `board-944` }), this.$store.dispatch("approval/LOAD_POST_ALL", { ...apiOptions, boardSlug: `board-945` })]);

      const post944 = res944 && res944.data && res944.data.length > 0 ? res944.data[0] : null;
      const post945 = res945 && res945.data && res945.data.length > 0 ? res945.data[0] : null;

      if (post944) this.connect944Id = post944.post_id;
      if (post945) this.connect945Id = post945.post_id;
      if (typeof this.funcRefreshButtons === 'function') this.funcRefreshButtons();
    }
  },
  methods: {
    setNormalBoardButtons (template) {
      const 위험성평가개선전 = {
        shouldShow: { mode: "u", freePass: 0, permission: "c|u", onlyWriter: true },
        component: "vs-button",
        props: { class: "col-span-2", color: "secondary", type: "border" },
        content: "위험성평가(개선전)",
        icon:"icon-external-link",
        emits: {
          click: (/*func*/) => {
           this.movePage(0);
          },
        },
      };
      const 위험성평가개선후 = {
        shouldShow: { mode: "u", freePass: 0, permission: "c|u", onlyWriter: true, custom: this.connect944Id > 0 },
        component: "vs-button",
        props: { class: "col-span-2", color: "secondary", type: "border" },
        content: "위험성평가(개선후)",
        icon:"icon-external-link",
        emits: {
          click: (/*func*/) => {
            this.movePage(1);
          },
        },
      };

      template.save.emits.click = (func) => {

        func.save( async () => {

          const list = await this.$store.dispatch("board/LOAD_POST_LIST", {
            projectId: this.projectId,
            boardId: 1107,
            page:1,
            perPage:1,
            conditions: [{ key: "body.connect823Id", operator: "=", value: `${this.postId}` }],
          });

          if (list.data.length === 0 && this.form.subInfo.구분 === '직영') {
            const body = {
              stdInfo: this.form.stdInfo,
              subInfo: this.form.subInfo,
              connect823Id: this.postId
            }
            body.subInfo.안전보건위원회 = { "승인여부": "", "날짜": "" };
            body.subInfo.노무위원회 = { "승인여부": "", "날짜": "" };
            body.subInfo.징계결과 = { "구분": "", "value": "" };

            const content = JSON.stringify({
              header: {
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                date: new Date().format("yyyy-MM-dd"),
                full: new Date().format("yyyy-MM-dd")
              },
              body,
            })
            const response = await this.$store.dispatch('board/CREATE_POST', {
              projectId: this.projectId,
              boardId: 1107,
              title: '재해자 징계현황(직영)',
              content
            })
          }
        });
      }
      return [위험성평가개선전, 위험성평가개선후, template.print, template.delete, template.move, template.save]
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.subInfo.재해일시.required) return "재해일시를 반드시 입력해야 합니다";

        if (this.warningInfo) return "복직일은 재해일시 이후로 입력해야 합니다";
      }
    },
    /**
     * 개선전, 개선후 게시글 생성 페이지로 이동
     * 만약 작성된 페이지가 존재하면 작성된 페이지로 이동
     * 0: 개선전, 1: 개선후
     */
    movePage(type) {
      // 페이지 이동동
      switch (type) {
        case 0:
          if (this.connect944Id) {
            this.$router.push({
              name: "write|update|tab",
              params: {
                boardId: "944",
                boardSlug: "board-944",
                pageType: "write",
                proj_id: this.projectId,
                postId: this.connect944Id,
              },
            });
          } else {
            this.$store.commit("board/SET_BOARD_CONNECT_823", this.postId);
            this.$router.push({
              name: "write|tab",
              params: {
                boardId: "944",
                boardSlug: "board-944",
                pageType: "write",
                proj_id: this.projectId,
              },
            });
          }
          break;
        case 1:
          if (this.connect945Id) {
            this.$router.push({
              name: "write|update|tab",
              params: {
                boardId: "945",
                boardSlug: "board-945",
                pageType: "write",
                proj_id: this.projectId,
                postId: this.connect945Id,
              },
            });
          } else {
            this.$store.commit("board/SET_BOARD_CONNECT_823", this.postId);
            this.$router.push({
              name: "write|tab",
              params: {
                boardId: "945",
                boardSlug: "board-945",
                pageType: "write",
                proj_id: this.projectId,
              },
            });
          }
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-btn {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
